import React, { useEffect, useState } from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import DateInputWithArrows from './DateInputWithArrows';
import useResponsive from './responsive/useResponsive';

function toDateInputValue(expirationDate) {
  if (!expirationDate) return '';
  return String(expirationDate).slice(0, 10);
}

function UpdateFileDueDateDialog({
  open,
  onClose,
  currentExpirationDate,
  onSave,
  saving = false,
}) {
  const { t } = useTranslation();
  const { isMobile } = useResponsive();
  const [date, setDate] = useState('');

  useEffect(() => {
    if (open) {
      setDate(toDateInputValue(currentExpirationDate));
    }
  }, [open, currentExpirationDate]);

  const handleClose = () => {
    if (saving) return;
    onClose();
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      fullWidth
      maxWidth="xs"
      fullScreen={isMobile}
    >
      <DialogTitle>{t('common.updateDueDate')}</DialogTitle>
      <DialogContent sx={{ pt: 1 }}>
        <DateInputWithArrows
          fullWidth
          label={t('common.dueDate')}
          value={date}
          onChange={(e) => setDate(e.target.value)}
          disabled={saving}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} disabled={saving}>{t('common.cancel')}</Button>
        <Button onClick={() => onSave(null)} disabled={saving}>{t('common.turnOffDueDate')}</Button>
        <Button
          variant="contained"
          onClick={() => onSave(date)}
          disabled={saving || !date}
        >
          {t('common.save')}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default UpdateFileDueDateDialog;
